/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';

import VirtualBraindateEarlyReminderDumb from './VirtualBraindateEarlyReminderDumb';
import { dismissNotification } from 'src/shared/app/notification/action/uiNotificationActions';
import { getSelf } from 'src/shared/domain/user/selector/userSelectors';

import type { Notification } from 'src/shared/app/notification/type/notificationTypes';

type Props = {
  notification: Notification,
};

const mapStateToProps = (state: Object, { notification }: Props): Object => ({
  notification,
  user: getSelf(state),
});

const mapDispatchToProps = (dispatch: any): Object => ({ dispatch });

const mergeProps = (
  stateProps: Object,
  { dispatch }: Object,
  { notification }: Props,
): Object => ({
  ...stateProps,
  handleDismiss() {
    dispatch(dismissNotification(notification));
  },
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
)(VirtualBraindateEarlyReminderDumb);
